import React from 'react';
import { __ } from '@wordpress/i18n';
const NoCurrency = ( {
	modalOpen
} ) => {

    return (
        <div className='cmgf-nc-container'>
				<div className="cmgf-nc-status">
					{
					__('No currencies found.','currency-manager-for-gravity-forms')
					}
				</div>
				<div className="cmgf-nc-status-desc">{__(
											'Add a new currency or edit an existing currency.',
											'currency-manager-for-gravity-forms'
										)}</div>
				<div className="cmgf-nc-btns">
									<button
										className="cmgf-wrapper-button"
										onClick={ () =>
											modalOpen( {
												modalStatus: true,
												isUpdateModal: false,
												shouldAddDropdown: false,
											} )
										}
									>
										{ __( 'Add New Currency', 'currency-manager-for-gravity-forms' ) }
									</button>
					
									<button
										className="cmgf-wrapper-button"
										onClick={ () =>
											modalOpen( {
												modalStatus: true,
												isUpdateModal: true,
												shouldAddDropdown: true,
											} )
										}
									>
										{ __(
											'Edit existing Currency',
											'currency-manager-for-gravity-forms'
										) }
								</button>

				</div>
			</div>

    )
}

export default NoCurrency;